import React from 'react';

import styled from 'styled-components';

import CardView from 'apps/auth/components/common/Card/CardView';
import { Text } from 'apps/auth/components/common/Text/Text';
import { isCardExpired } from 'apps/auth/helpers/utils';
import { usePageMessages } from 'apps/auth/hooks/selectors';
import media from 'apps/auth/theme/media';

const CardWrap = styled.div`
    margin-bottom: 24px;
    min-height: 224px;
    display: flex;
    flex-direction: column;

    ${media.tablet720} {
        min-height: 304px;
    }
`;

const Card = (props) => {
    const { cardsCardExpiredDate, thisCardExpired, thisCardCanNotBeUsed } = usePageMessages();
    const card = props.card;
    if (card) {
        return (
            <>
                <CardWrap>
                    <CardView card={card} cardExpDateMessage={cardsCardExpiredDate} />
                </CardWrap>
                {isCardExpired(card) && (
                    <>
                        <Text variant="div" color="error" indent="16px">
                            {thisCardExpired}
                        </Text>
                        <Text variant="div" color="error">
                            {thisCardCanNotBeUsed}
                        </Text>
                    </>
                )}
            </>
        );
    } else {
        return null;
    }
};

export default Card;
